/**
 * `ColumnDef` list for the Suppliers table. Lean shape (no contact/tax fields):
 * code link · name · address · active status. Built on the shared masters status
 * renderer + `TableLink`.
 */
import type { ColumnDef } from '@vnetwork/ui/data';
import type { Supplier } from '@/api/capacities';
import { TableLink } from '@/components/table-link';
import { activeStatusCell } from '../../shared/masters-status';

const muted = { color: 'var(--vn-fg-muted)', fontStyle: 'italic' } as const;

export const supplierColumns: ColumnDef<Supplier, unknown>[] = [
  {
    id: 'code',
    header: 'Code',
    cell: ({ row }) => (
      <TableLink to={`/capacities/suppliers/${row.original.id}`} title={row.original.code}>
        {row.original.code || row.original.id}
      </TableLink>
    ),
  },
  {
    id: 'name',
    header: 'Supplier',
    cell: ({ row }) => (
      <span title={row.original.name} style={{ overflowWrap: 'anywhere' }}>
        {row.original.name}
      </span>
    ),
  },
  {
    id: 'address',
    header: 'Address',
    cell: ({ row }) =>
      row.original.address ? (
        <span
          title={row.original.address}
          style={{ display: 'block', maxWidth: 360, overflowWrap: 'anywhere' }}
        >
          {row.original.address}
        </span>
      ) : (
        <span style={muted}>—</span>
      ),
  },
  {
    id: 'is_active',
    header: 'Status',
    cell: ({ row }) => activeStatusCell(row.original.is_active),
  },
];
